export default {
  'menu.welcome': 'Bienvenue',
  'menu.more-blocks': 'Plus de blocs',
  'menu.home': 'Accueil',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sous-page',
  'menu.login': 'Connexion',
  'menu.register': "S'enregistrer",
  'menu.register.result': "Résultat de l'enregistrement",
  'menu.dashboard': 'Tableau de bord',
  'menu.dashboard.analysis': 'Analyse',
  'menu.dashboard.monitor': 'Surveillance',
  'menu.dashboard.workplace': 'Espace de travail',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulaire',
  'menu.form.basic-form': 'Formulaire de base',
  'menu.form.step-form': 'Formulaire étape par étape',
  'menu.form.step-form.info': 'Formulaire étape par étape (informations de transfert)',
  'menu.form.step-form.confirm':
    'Formulaire étape par étape (confirmer les informations de transfert)',
  'menu.form.step-form.result': 'Formulaire étape par étape (terminé)',
  'menu.form.advanced-form': 'Formulaire avancé',
  'menu.list': 'Liste',
  'menu.list.table-list': 'Tableau de recherche',
  'menu.list.basic-list': 'Liste de base',
  'menu.list.card-list': 'Liste de cartes',
  'menu.list.search-list': 'Liste de recherche',
  'menu.list.search-list.articles': 'Liste de recherche (articles)',
  'menu.list.search-list.projects': 'Liste de recherche (projets)',
  'menu.list.search-list.applications': 'Liste de recherche (applications)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Profil de base',
  'menu.profile.advanced': 'Profil avancé',
  'menu.result': 'Résultat',
  'menu.result.success': 'Succès',
  'menu.result.fail': 'Échec',
  'menu.exception': 'Erreur',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Déclencheur',
  'menu.account': 'Compte',
  'menu.account.center': 'Centre de compte',
  'menu.account.settings': 'Paramètres du compte',
  'menu.account.trigger': "Déclencheur d'erreur",
  'menu.account.logout': 'Déconnexion',
  'menu.editor': 'Éditeur graphique',
  'menu.editor.flow': 'Éditeur de flux',
  'menu.editor.mind': "Éditeur de l'esprit",
  'menu.editor.koni': 'Éditeur Koni',
  'menu.reports': 'Rapports',
};
